import { actionsFromList } from '@mgc/map-client-shared/lib/ReduxTools';
import sentry from '../sentry';

class ErrorActions {
    static types = actionsFromList([
        'AUTH_ERROR',
        'TRANSFER_ERROR',
        'CATCH_ERROR',
        'SET_ERROR_MESSAGE',
    ]);

    static errorHandler(dispatch) {
        return (error) => {
            sentry.logException(error);
            console.log(error);

            if (error.request && error.request.status === 401) {
                dispatch(ErrorActions.authError(error));
            } else {
                dispatch(ErrorActions.transferError(error));
            }
            throw error;
        };
    }

    // sync --------------------------------------------------------------------

    static transferError = (error) => ({
        type: ErrorActions.types.TRANSFER_ERROR,
        payload: { error },
    });

    static authError = (error) => ({
        type: ErrorActions.types.AUTH_ERROR,
        payload: { error },
    });

    static catchError = (error) => {
        sentry.logException(error);
        console.error(error);

        return {
            type: ErrorActions.types.CATCH_ERROR,
            payload: { error },
        };
    };

    static setErrorMessage = (message) => ({
        type: ErrorActions.types.SET_ERROR_MESSAGE,
        payload: { message },
    });
}

export default ErrorActions;



// WEBPACK FOOTER //
// ./app/actions/error.js